<template>
  <MDBRow class="mb-4"
    ><MDBCol>
      <MDBBtn color="dark" @click="moveWorld" style="float: left">
        <MDBIcon icon="long-arrow-alt-left" iconStyle="fas" /> Back to World
      </MDBBtn>
    </MDBCol>
  </MDBRow>
  <div v-if="correct">
    <h2>{{ data.title }}</h2>
    <MDBRow class="row-cols-2 row-cols-md-3 row-cols-lg-4">
      <MDBCol v-for="(s, index) in data.zones" :key="s['img']">
        <MDBCard
          text="white"
          bg="dark"
          class="mb-3 click-card"
          @click="moveZone(index + 1)"
        >
          <MDBCardImg :src="'images/world/' + s['img'] + '.png'" top />
          <MDBCardBody>
            <MDBCardTitle>{{ s["title"] }}</MDBCardTitle>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>
  </div>
  <div v-else>Wrong Name</div>
</template>

<script>
// import { useStore } from "vuex";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  // MDBCardText,
  MDBCardImg,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
} from "mdb-vue-ui-kit";
export default {
  components: {
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    // MDBCardText,
    MDBCardImg,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBIcon,
  },
  computed: {
    maps() {
      return this.$store.getters.getMaps;
    },
    correct() {
      return this.area in this.maps;
    },
    data() {
      if (this.correct) {
        return this.maps[this.area];
      }
      return false;
    },
  },
  // async setup() {
  //   const store = useStore();
  //   await store.dispatch("requestMaps");
  // },
  methods: {
    moveZone(z) {
      this.$router.push("/world/" + this.area + "/" + z);
    },
    moveWorld() {
      this.$router.push("/world/");
    },
  },
  data() {
    return {
      area: this.$route.params.area,
    };
  },
  created() {
    document.title = "Area";
  },
};
</script>

<style></style>
